import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "content", "sectionTab"]

  switch(event) {
    event.preventDefault()
    const targetTab = event.currentTarget.dataset.tab

    const allActiveClasses = [
      ...new Set(
        this.tabTargets.flatMap((tab) => (tab.dataset.activeClass || "").split(" ").filter(Boolean))
      ),
    ]

    this.tabTargets.forEach((tab) => {
      tab.classList.remove(...allActiveClasses)

      if (tab.dataset.tab === targetTab) {
        const activeClasses = (tab.dataset.activeClass || "").split(" ").filter(Boolean)
        tab.classList.add(...activeClasses)
      }
    })

    this.contentTargets.forEach((content) => {
      content.classList.toggle("hidden", content.dataset.tab !== targetTab)
    })
  }

  scrollToSection(event) {
    event.preventDefault()

    const section = document.querySelector(event.currentTarget.getAttribute("href"))
    if (!section) return

    this.sectionTabTargets.forEach((tab) => {
      const isCurrent = tab === event.currentTarget
      tab.classList.toggle("dashboard-page__section-tab--active", isCurrent)

      if (isCurrent) {
        tab.setAttribute("aria-current", "location")
      } else {
        tab.removeAttribute("aria-current")
      }
    })

    section.scrollIntoView({
      behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth",
      block: "start",
    })
  }
}
